module.exports = __webpack_public_path__ + "assets/images/caixa-final-da-revista_89cab47cb9f0241cea5e5a76fe139832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-ten/caixa-final-da-revista.png
// module id = 253
// module chunks = 0